<template>
  <div>
    <div class="owner_title">金主日结表</div>
    <div class="daySheet_box">
      <div class="search_box">
        <el-input
          placeholder="请输入内容"
          v-model="searchTxt"
          class="input-with-select"
        >
          <el-select
            v-model="select"
            slot="prepend"
            @change="changeSelect"
            placeholder="请选择"
          >
            <el-option label="金主昵称" value="1"></el-option>
            <el-option label="书名" value="2"></el-option>
          </el-select>
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="searchBtn"
          ></el-button>
        </el-input>
      </div>
    </div>

    <div class="task_box">
      <!-- 表格数据 -->
      <el-table :data="dataShow" height="550" border>
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="connectionessay_name"
          label="书名"
          align="center"
          sortable
          :width="equipmentType == 0 ? 205 : 90"
        ></el-table-column>
        <el-table-column
          property="connection_name"
          label="金主昵称"
          align="center"
          sortable
          :width="equipmentType == 0 ? 110 : 101"
        ></el-table-column>
        <el-table-column
          property="start_chapters"
          label="开始章节"
          align="center"
          sortable
          :width="equipmentType == 0 ? 110 : 101"
        ></el-table-column>
        <el-table-column
          property="end_chapters"
          label="结束章节"
          align="center"
          sortable
          :width="equipmentType == 0 ? 110 : 101"
        ></el-table-column>
        <el-table-column
          property="actual_cost"
          label="金主给的千字价格"
          align="center"
          sortable
          :width="equipmentType == 0 ? 160 : 158"
        ></el-table-column>
        <el-table-column
          property="each_chapter_num"
          label="每章字数"
          align="center"
          sortable
          :width="equipmentType == 0 ? 120 : 101"
        >
        </el-table-column>
        <el-table-column
          property="word_number"
          label="日结总字数"
          align="center"
          sortable
          :width="equipmentType == 0 ? 120 : 130"
        >
        </el-table-column>
        <el-table-column
          property="frequency"
          label="日结第几天"
          align="center"
          sortable
          :width="equipmentType == 0 ? 130 : 120"
        >
        </el-table-column>
        <el-table-column
          property="fee"
          label="应结算金额"
          align="center"
          sortable
          :width="equipmentType == 0 ? 120 : 120"
        >
        </el-table-column>
        <el-table-column
          property="w_fee"
          label="未结算金额"
          align="center"
          sortable
          :width="equipmentType == 0 ? 120 : 120"
        >
        </el-table-column>
        <el-table-column
          property="is_task"
          label="任务状态"
          align="center"
          sortable
          :width="equipmentType == 0 ? 120 : 110"
        >
          <!-- 任务状态:0=未开始(灰色tag_gray),1=进行中(蓝色)tag_blue,2=已完结(绿色)tag_green,-1=已停止(红色tag_red) -->
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.is_task == '-1'
                  ? 'danger'
                  : scope.row.is_task == '0'
                  ? 'info'
                  : scope.row.is_task == '1'
                  ? ''
                  : 'success'
              "
            >
              <div
                class="tag_circle"
                :class="[
                  scope.row.is_task == '-1'
                    ? 'tag_red'
                    : scope.row.is_task == '0'
                    ? 'tag_gray'
                    : scope.row.is_task == '1'
                    ? 'tag_blue'
                    : 'tag_green'
                ]"
              ></div>
              {{
                scope.row.is_task == "-1"
                  ? "已停止"
                  : scope.row.is_task == "0"
                  ? "未开始"
                  : scope.row.is_task == "1"
                  ? "进行中"
                  : "已完结"
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          property="createtime"
          label="创建时间"
          align="center"
          sortable
          :width="equipmentType == 0 ? 180 : 110"
        >
        </el-table-column>
        <el-table-column
          property="start_time"
          label="开始时间"
          align="center"
          sortable
          :width="equipmentType == 0 ? 180 : 110"
        >
        </el-table-column>
        <el-table-column
          property="end_time"
          label="结束时间"
          align="center"
          sortable
          :width="equipmentType == 0 ? 180 : 110"
        >
        </el-table-column>
        <el-table-column
          :fixed="equipmentType == 1 ? false : 'right'"
          label="操作"
          align="center"
          width="110"
        >
          <template slot-scope="scope">
            <div @click="detailtDialog(scope.row)" class="reject_record_btn">
              <i class="iconfont icon-zongcejieguochakan"></i>
              查看详情
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="pagination_box"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>

      <!-- 查看详情弹窗 -->
      <el-dialog
        :visible.sync="detailDialogVisible"
        title="日结表详情"
        @close="cancelDialog"
        width="90%"
      >
        <el-table :data="dataShowDialog" border>
          <el-table-column type="index" label="序号" align="center" width="50">
          </el-table-column>

          <el-table-column
            property="connection_name"
            sortable
            label="金主昵称"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            property="connectionessay_name"
            sortable
            label="书名"
            width="260"
            align="center"
          ></el-table-column>
          <el-table-column
            property="start_chapters"
            sortable
            label="开始章节"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            property="end_chapters"
            sortable
            label="结束章节"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            property="actual_cost"
            sortable
            label="金主给的千字价格"
            align="center"
            width="180"
          ></el-table-column>
          <el-table-column
            property="each_chapter_num"
            sortable
            label="每章字数"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            property="number_chapters"
            sortable
            label="章节数"
            width="110"
            align="center"
          ></el-table-column>
          <el-table-column
            property="word_number"
            sortable
            label="日结总字数"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            property="settlement_type"
            sortable
            label="日周结"
            width="110"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.settlement_type == '2' ? '' : 'warning'">
                {{ scope.row.settlement_type == "2" ? "周结" : "日结" }}
              </el-tag>
            </template></el-table-column
          >
          <el-table-column
            property="is_settle"
            sortable
            label="结算状态"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.is_settle == '0' ? 'info' : 'success'">
                {{ scope.row.is_settle == "0" ? "未结算" : "已结算" }}
              </el-tag>
            </template></el-table-column
          >

          <el-table-column
            property="frequency"
            sortable
            label="日结第几天"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            property="status"
            sortable
            label="是否通过"
            width="140"
            align="center"
            ><template slot-scope="scope">
              <el-tag
                :type="
                  scope.row.status == '0'
                    ? ' '
                    : scope.row.status == '1'
                    ? 'success'
                    : 'danger'
                "
              >
                {{
                  scope.row.status == "0"
                    ? "审查中"
                    : scope.row.status == "1"
                    ? "通过"
                    : "驳回"
                }}
              </el-tag>
            </template></el-table-column
          >
          <el-table-column
            property="fee"
            sortable
            label="应收收稿费"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            property="w_fee"
            sortable
            label="未收稿费"
            width="150"
            align="center"
          ></el-table-column>

          <el-table-column
            property="createtime"
            sortable
            label="创建时间"
            width="250"
            align="center"
          ></el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChangeDialog"
          @current-change="handleCurrentChangeDialog"
          :current-page="currentPageDialog"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSizeDialog"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDialog"
        >
        </el-pagination>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  connectionrecord_history_list_week,
  connectionrecord_history_list
} from "@/utils/owner";
export default {
  data() {
    return {
      daySheetList: [], //日结表列表
      isFilterForm: false, //筛选表单
      daySheetDetail: [], //详情列表
      dataShow: [], // 当前页要显示的数据,//显示的金主列表数据

      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      // 筛选
      filter_form: {
        name: "", //金主昵称
        qq_account: "", //金主QQ
        wx_account: "", //金主微信
        mobile: "", //金主电话号码
        status: "", //金主状态 默认0  0=新入库,1=合作中,2=合作过
        createtime: "", //创建时间范围
        is_task: "", //是否有任务:0=无任务,1=有任务  默认空
        connectionlabel_id: "" //标签
      },
      dataShowDialog: [], //弹窗数据
      totalPageDataDialog: [], // 分页数据(全部数据已经分好页)
      pageNumDialog: 1, // 共几页
      pageSizeDialog: 10, // 每页显示数量
      currentPageDialog: 1, // 当前显示页码
      totalDialog: 1, // 总共多少条数据
      searchTxt: "", //搜索内容
      select: "", //搜索的筛选
      selectId: "", //筛选项的id
      detailDialogVisible: false, //查看详情弹窗
      equipmentType: 0 //判断移动端还是pc端  0：pc  1：移动
    };
  },
  created() {
    this.ownerId = JSON.parse(localStorage.getItem("userInfo")).id;
    if (this.$isMobile.isDeviceType()) {
      this.equipmentType = 1;
    } else {
      this.equipmentType = 0;
    }
    this.getDaySheetList();
  },
  methods: {
    // 获取金主日结表
    getDaySheetList() {
      var that = this;
      let obj = {
        departmentuser_id: that.ownerId,
        page: 1,
        page_index: 10
      };
      connectionrecord_history_list_week(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.daySheetList = res.data.data;
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 搜索的筛选
    changeSelect(val) {
      var that = this;
      that.selectId = val;
    },
    // 搜索按钮
    searchBtn() {
      var that = this;
      var obj;
      if (that.selectId == 1) {
        //根据金主昵称
        obj = {
          departmentuser_id: that.ownerId,
          connection_name: that.searchTxt, //金主昵称
          page: 1,
          page_index: 10
        };
      } else {
        obj = {
          departmentuser_id: that.ownerId,
          connectionessay_name: that.searchTxt, //书名
          page: 1,
          page_index: 10
        };
      }
      connectionrecord_history_list_week(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.daySheetList = res.data.data;
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 查看详情弹窗
    detailtDialog(val) {
      console.log(val);
      var that = this;
      that.detailDialogVisible = true;
      let obj = {
        departmentuser_id: that.ownerId,
        connectionessay_id: val.connectionessay_id,
        connection_expand_id: val.connection_expand_id,
        start_time: val.start_time,
        end_time: val.end_time,
        page: 1,
        page_index: 10
      };
      connectionrecord_history_list(obj).then(res => {
        if (res.data.code == 1) {
          that.totalDialog = res.data.data.length;
          that.daySheetDetail = res.data.data;
          that.calcPageDataDialog();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    },
    // 关闭弹窗触发
    cancelDialog() {
      this.searchBtn();
    },
    calcPageData() {
      if (this.daySheetList.length > 1) {
        this.pageNum = Math.ceil(this.daySheetList.length / this.pageSize) || 1;
      }
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.daySheetList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }
      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.dataShow = this.totalPageData[val - 1];
    },
    calcPageDataDialog() {
      if (this.daySheetDetail.length > 1) {
        this.pageNumDialog =
          Math.ceil(this.daySheetDetail.length / this.pageSizeDialog) || 1;
      }
      for (let i = 0; i < this.pageNumDialog; i++) {
        this.totalPageDataDialog[i] = this.daySheetDetail.slice(
          this.pageSizeDialog * i,
          this.pageSizeDialog * (i + 1)
        );
      }
      this.dataShowDialog = this.totalPageDataDialog[
        this.currentPageDialog - 1
      ];
    },
    handleSizeChangeDialog(val) {
      this.pageSizeDialog = val;
      this.calcPageDataDialog();
    },
    handleCurrentChangeDialog(val) {
      this.currentPageDialog = val;
      this.dataShowDialog = this.totalPageDataDialog[val - 1];
    }
    // // 计算页数的方法
    // calcPageData(data, index) {
    //   if (data.length > 1) {
    //     this.pageNum = Math.ceil(data.length / this.pageSize) || 1;
    //   }
    //   //数据分组
    //   for (let i = 0; i < this.pageNum; i++) {
    //     this.totalPageData[i] = data.slice(
    //       this.pageSize * i,
    //       this.pageSize * (i + 1)
    //     );
    //   }
    //   if (index == 0) {
    //     // 列表的分页数据
    //     this.dataShow = this.totalPageData[this.currentPage - 1];
    //   } else {
    //     // 弹窗的分页数据
    //     this.dataShowDialog = this.totalPageData[this.currentPage - 1];
    //   }
    // },
    // handleSizeChange(val) {
    //   var that = this;
    //   this.pageSize = val;
    //   if (that.daySheetList.length > 0) {
    //     this.total = that.daySheetList.length;
    //     this.calcPageData(that.daySheetList, 0);
    //   }
    //   // 弹窗的条数选择
    //   if (that.daySheetDetail.length > 0) {
    //     this.total = that.daySheetDetail.length;
    //     this.calcPageData(that.daySheetDetail, 1);
    //   }
    // },
    // handleCurrentChange(val) {
    //   this.currentPage = val;
    //   // 注意数组是从0开始，页码别忘了减去1
    //   this.dataShow = this.totalPageData[val - 1];
    //   this.dataShowDialog = this.totalPageData[val - 1];
    // }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}

.record_btn {
  /* width: 200px; */
  height: 25px;
  text-align: center;
  line-height: 6px;
  background: #f3f8ff;
  color: #157df8;
}
.sea_icon {
  font-size: 12px;
}
.daySheet_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 10px 0px 15px;
}
.daySheet_box .el-form-item {
  margin-bottom: 10px;
}
.task_filtrate {
  text-align: right;
  padding: 10px 15px 10px 15px;
}

.task_filtrate i {
  font-size: 14px;
}
.task_filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.task_filter_form {
  width: 96%;
  height: 100px;
  background: #ffffff;
  margin: 0px 15px;
  padding: 15px;
}
.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.tag_red {
  background: #f56c6c;
}
.tag_blue {
  background: #409eff;
}
.tag_green {
  background: #67c23a;
}
.tag_gray {
  background: #909399;
}
.task_box {
  margin: 0px 15px;
}
.search_box {
  margin-bottom: 10px;
}
.search_box .input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.search_box .el-select {
  width: 130px;
}
.reject_record_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  border-radius: 10px;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
}
.reject_record_btn i {
  font-size: 12px;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .task_box {
    margin-bottom: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/owner/OwnerDaySheet.vue